import React from 'react';

import BreadcrumbNav from '../../../view/nav/BreadcrumbNav';
import CONF from '../../../api/config';
import CalendarMessagingSummaryDrawer from '../../messaging/components/CalendarMessagingSummaryDrawer';
import CalendarMessagingDrawer from '../../../view/calendar/components/CalendarMessagingDrawer';
import openCalendarMessagingSummaryDrawer from '../../messaging/state/openCalendarMessagingSummaryDrawer';
import FilterDropdown from './FilterDropdown';
import DateSelection from './DateSelection';
import useHomeEvents from './hooks/useHomeEvents';
import useHomeNavigation from './hooks/useHomeNavigation';
import CoachOnboarding from './CoachOnboarding';
import FeatureFlag from '../../features/components/FeatureFlag';
import { FEATURES } from '../../features/components/constants';
import useFeatureFlag from '../../features/components/useFeatureFlag';
import TrialKPICard from './TrialKPICard';

const NOW = Date.now();

const ALERTS_PATH = `${CONF.ADAPTER}/alerts?timestamp=${NOW}`;

const getDirectMessagePath = (
    athleteId,
    teamId,
    programWorkoutId,
    dateString,
    sessionId
) => {
    /* eslint-disable */
    return `${
        CONF.ADAPTER
    }/messaging/direct/${athleteId}?timestamp=${NOW}&teamId=${teamId}&programWorkoutId=${programWorkoutId}&date=${dateString}&sessionId=${sessionId}`;
};

const getTeamMessagePath = teamId => {
    /* eslint-disable */
    return `${CONF.ADAPTER}/messaging/team/${teamId}?timestamp=${NOW}`;
};

const homeStreamLink = `${CONF.ADAPTER}/home?timestamp=${NOW}`;

export default function Home() {
    const { crumbs } = useHomeNavigation();

    const {
        onFilterChange,
        filters,
        emit,
        onDateChange,
        directMessageSession,
        teamMessageSession,
        referenceHandle,
        directMessageDrawerAthleteId,
        setDirectMessageDrawerAthleteId,
        teamChannelTeamId,
        setTeamChannelTeamId
    } = useHomeEvents(openCalendarMessagingSummaryDrawer);

    const hasFeatureFlag = useFeatureFlag();

    const {
        id: sessionId,
        teamId,
        programWorkoutId,
        dateString
    } = directMessageSession.current;

    const directMessagePath = getDirectMessagePath(
        directMessageDrawerAthleteId,
        teamId,
        programWorkoutId,
        dateString,
        sessionId
    );

    const hasTwoPanes = hasFeatureFlag(FEATURES.MOBILE_LOW_PROGRAMMING);

    return (
        <React.Fragment>
            <BreadcrumbNav crumbs={crumbs} />
            <div className="home-container">
                <div className="home-landing">
                    <div className="home-frame">
                        <div
                            className={`home-filters content-width ${
                                hasTwoPanes ? '' : 'fix-width'
                            }`}
                        >
                            <div className="filter-row">
                                <FilterDropdown
                                    filters={filters}
                                    onChange={onFilterChange}
                                />
                                <div className="date-filter-container">
                                    <DateSelection
                                        onDateChange={onDateChange}
                                    />
                                </div>
                            </div>
                            <div />
                        </div>
                        <div
                            className={`content-width home-content ${
                                hasTwoPanes ? '' : 'fix-width'
                            }`}
                        >
                            <iframe
                                ref={referenceHandle}
                                title="home"
                                frameBorder="none"
                                src={homeStreamLink}
                                allowFullScreen={true}
                                className="home-frame"
                            />
                            <div className="home-right-rail">
                                <TrialKPICard />
                                <FeatureFlag
                                    feature={FEATURES.MOBILE_LOW_PROGRAMMING}
                                >
                                    <div className="needs-programming">
                                        <iframe
                                            title="alerts"
                                            frameBorder="none"
                                            style={{ border: 'none' }}
                                            src={ALERTS_PATH}
                                            allowFullScreen={true}
                                            className="content-width"
                                        />
                                    </div>
                                </FeatureFlag>
                            </div>
                        </div>
                    </div>
                </div>
                <CoachOnboarding />
            </div>
            <CalendarMessagingSummaryDrawer
                callback={() => {
                    emit(
                        'home-refresh-session-card',
                        teamMessageSession.current
                    );
                }}
            />
            {directMessageDrawerAthleteId && (
                <CalendarMessagingDrawer
                    path={directMessagePath}
                    messageDrawerOpen={true}
                    onClose={() => {
                        setDirectMessageDrawerAthleteId(null);
                    }}
                />
            )}
            {teamChannelTeamId && (
                <CalendarMessagingDrawer
                    path={getTeamMessagePath(teamChannelTeamId)}
                    messageDrawerOpen={true}
                    onClose={() => {
                        setTeamChannelTeamId(null);
                    }}
                />
            )}
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/v5/home/components/Home.jsx